<template>
  <label class="fcs-radio">
    <slot></slot>
    <span class="checkbox large">{{ buttonText }}</span>
  </label>
</template>

<script>
export default {
  props: {
    buttonText: String
  }
}
</script>